import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { filterChange, 
    popUpMessageChange, 
    signaturesFilterChange, 
    signaturesFilterHistoricChange, 
    signaturesUserChange} from '../../actions/index'

import { Button } from '@material-ui/core';

import { _ } from '../../functions/translator.js';
import { postData } from '../../functions/postData.js';
import { showMessage } from '../../functions/popUpMessage.js';
import { FilterActions } from '../../constants/constants.js';
import { toggleSwitch } from '../../actions/index';
import { ToggleActions } from '../../constants/constants.js';

class SignaturesFilterOption extends React.Component{

    handleSigned = () => {
        this.getSignedCardsGroups(true);
        this.props.signaturesFilterChange([]);
        this.props.signaturesUserChange([]);
    }

    handleNotSigned = () => {
        this.getSignedCardsGroups(false);
        this.props.signaturesFilterChange([]);
        this.props.signaturesUserChange([]);
    }

    getSignedCardsGroups = async (signed) => {
        if (this.props.signaturesUserId.length !== 0){
            showMessage(this.props, _('Filtrando') + '...', { loading: true });
            let and_or = ''
            let urlPost = {}
            if(typeof(this.props.signaturesFilter[0]) == "string"){
                and_or = 'or'
                urlPost = {
                    project_id: window.project_id,
                    filter_user_id: this.props.signaturesUserId,
                    cards_group_ids: this.props.visibleCardsGroupIds,
                    and_or,
                    positions:this.props.signaturesFilter,
                }
            } else {
                and_or = 'and'
                urlPost = {
                    project_id: window.project_id,
                    filter_user_id: this.props.signaturesUserId,
                    cards_group_ids: this.props.visibleCardsGroupIds,
                    and_or
                }
            }
            let response = null;
            if (signed) {
                response = await postData('/web-api/get-user-signed-cards-groups', urlPost);
            } else {
                response = await postData('/web-api/get-non-signed-cards-groups-by-user', urlPost);
            }
            this.handleResponse(response, signed)
        } else {
            showMessage(this.props, '¡' + _('Debes seleccionar al menos un usuario o cargo para filtrar') + '!');
        }
    }

    handleResponse = (response, signed) => {
        if (response.status === 'success') {
            showMessage(this.props, '¡' + _('Filtro Aplicado') + '!');
            this.filterSignedCardsGroups(signed, response);
            const signaturesFilterHistoric = this.props.signaturesFilterHistoric
            const signaturesFilter = this.props.signaturesFilter
            signaturesFilterHistoric.push({
                signed,
                signaturesFilter
            })
            this.props.signaturesFilterHistoricChange(signaturesFilterHistoric)
            this.props.toggleSwitch(ToggleActions.METRICS, false)
            this.props.toggleSwitch(ToggleActions.SIGNATURES_FILTER, true);

        } else {
            showMessage(this.props, _('Ocurrió un error al filtrar') + '.');
        }
    }

    filterSignedCardsGroups = (signed, response) => {
        const cardsGroupIds = signed ? response.signed_cards_group_ids : response.non_signed_cards_group_ids;
        this.props.filterChange(FilterActions.CARDS_GROUP_IDS, cardsGroupIds);
    }
    
    render(){
        return (
            <div>
                <div className="d-flex justify-content-around mt-4">
                    <Button variant="contained" className='message-btn-width' onClick={ this.handleSigned }>
                        { _('Firmados') }
                    </Button>
                    <Button variant="contained" className='message-btn-width' onClick={ this.handleNotSigned }>
                        { _('Sin Firmar') }
                    </Button>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        signaturesUserId     : state.signaturesUserId,
        visibleCardsGroupIds : state.visibleCardsGroupIds,
        signaturesFilter     : state.signaturesFilter,
        signaturesFilterHistoric : state.signaturesFilterHistoric,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        filterChange : filterChange,
        popUpMessageChange : popUpMessageChange,
        signaturesFilterHistoricChange : signaturesFilterHistoricChange,
        toggleSwitch : toggleSwitch,
        signaturesUserChange: signaturesUserChange,
        signaturesFilterChange: signaturesFilterChange,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(SignaturesFilterOption)